import { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { actions as notificationsActions } from 'features/notifications';

const POLL_INTERVAL = 10 * 2000;

const AsyncPollNotifications = ({ getNotifications, isAuth, lang }) => {
  useEffect(() => {
    let timeoutId = null;
    let isCancelled = false;

    async function pollNotifications() {
      if (!isAuth) return;

      try {
        await getNotifications();
      } finally {
        if (!isCancelled) {
          timeoutId = setTimeout(pollNotifications, POLL_INTERVAL);
        }
      }
    }

    pollNotifications();

    return () => {
      isCancelled = true;

      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [getNotifications, isAuth, lang]);

  return null;
};

function mapStateToProps(state) {
  return {
    isAuth: state.auth.isAuth,
    lang: state.locale.lang,
  };
}

function mapDispatchToProps(dispatch) {
  const actions = {
    getNotifications: notificationsActions.getNotifications,
  };
  return bindActionCreators(actions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AsyncPollNotifications);